import type {
  VendorWithRelations,
  VendorCategory,
  CreateVendorInput,
  UpdateVendorInput,
  AddVendorCategoryInput,
  AddVendorContactInput,
} from '@peles/shared';
import { apiClient } from './client';

export async function listVendors(filters?: {
  isActive?: boolean;
  city?: string;
  vendorCategoryId?: string;
}): Promise<VendorWithRelations[]> {
  const params = new URLSearchParams();
  if (filters?.isActive !== undefined) params.set('isActive', String(filters.isActive));
  if (filters?.city) params.set('city', filters.city);
  if (filters?.vendorCategoryId) params.set('vendorCategoryId', filters.vendorCategoryId);

  const { data } = await apiClient.get<VendorWithRelations[]>('/vendors', { params });
  return data;
}

export async function getVendor(id: string): Promise<VendorWithRelations> {
  const { data } = await apiClient.get<VendorWithRelations>(`/vendors/${id}`);
  return data;
}

export async function createVendor(input: CreateVendorInput): Promise<VendorWithRelations> {
  const { data } = await apiClient.post<VendorWithRelations>('/vendors', input);
  return data;
}

export async function updateVendor(
  id: string,
  updates: UpdateVendorInput,
): Promise<VendorWithRelations> {
  const { data } = await apiClient.patch<VendorWithRelations>(`/vendors/${id}`, updates);
  return data;
}

export async function deactivateVendor(id: string): Promise<VendorWithRelations> {
  const { data } = await apiClient.delete<VendorWithRelations>(`/vendors/${id}`);
  return data;
}

export async function addVendorCategory(
  vendorId: string,
  input: AddVendorCategoryInput,
): Promise<VendorWithRelations> {
  const { data } = await apiClient.post<VendorWithRelations>(
    `/vendors/${vendorId}/categories`,
    input,
  );
  return data;
}

export async function removeVendorCategory(vendorId: string, categoryId: string): Promise<void> {
  await apiClient.delete(`/vendors/${vendorId}/categories/${categoryId}`);
}

export async function addVendorContact(
  vendorId: string,
  input: AddVendorContactInput,
): Promise<VendorWithRelations> {
  const { data } = await apiClient.post<VendorWithRelations>(
    `/vendors/${vendorId}/contacts`,
    input,
  );
  return data;
}

export async function removeVendorContact(vendorId: string, userId: string): Promise<void> {
  await apiClient.delete(`/vendors/${vendorId}/contacts/${userId}`);
}

export async function listVendorCategories(): Promise<VendorCategory[]> {
  const { data } = await apiClient.get<VendorCategory[]>('/vendor-categories');
  return data;
}
